import { Component, input } from '@angular/core';
import type { OnyxIconName } from '../../icons/interfaces';
import { OnyxIconComponent } from '../../icons/onyx-icon/onyx-icon.component';
import type { OnyxColor } from '../interfaces';

@Component({
  selector: 'onyx-badge',
  imports: [OnyxIconComponent],
  templateUrl: './onyx-badge.component.html',
  styleUrl: './onyx-badge.component.scss',
})
export class OnyxBadgeComponent {
  public readonly color = input.required<OnyxColor>();
  public readonly size = input<16 | 20 | 24>(24);
  public readonly circle = input(true);
  public readonly leftIcon = input<OnyxIconName>();
}
